// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copyable {
  box-sizing: border-box;
  display: block;
  padding: 32px 16px 16px;
  margin: 1em 0;
  background: #f8f9fc;
  border: solid 1px #dde3f0;
  border-radius: 3px;
  position: relative;
}

.copyable:before {
  content: 'Copyable';
  display: block;
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  color: #97a1b3;
  position: absolute;
  top: 12px;
  left: 16px;
  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}


.copyable__label:before,
.copyable__text:before {
  content: 'Title (default is "Example")';
  display: block;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #505762;
  margin-bottom: 4px;
  position: absolute;
  bottom: 100%;
  left: 0;
}

.copyable__text:before {
  content: "Content";
}

.copyable__label,
.copyable__text {
  box-sizing: border-box;
  display: block;
  font-size: 14px;
  line-height: 20px;
  padding: 0px 7px;
  margin: 0;
  margin-top: 32px;
  background: #fff;
  border-radius: 3px;
  font-family: sans-serif;
  position: relative;
}

.copyable__label,
.copyable__text {
  padding: 7px;
}

.copyable__text p {
  margin: 8px 0;
}

.ck .copyable__label.ck-editor__nested-editable,
.ck .copyable__text.ck-editor__nested-editable {
  border: solid 1px #dde3f0;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/copyable/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;;AAGA;;EAEE,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".copyable {\n  box-sizing: border-box;\n  display: block;\n  padding: 32px 16px 16px;\n  margin: 1em 0;\n  background: #f8f9fc;\n  border: solid 1px #dde3f0;\n  border-radius: 3px;\n  position: relative;\n}\n\n.copyable:before {\n  content: 'Copyable';\n  display: block;\n  font-size: 10px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #97a1b3;\n  position: absolute;\n  top: 12px;\n  left: 16px;\n  font-family: sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n\n.copyable__label:before,\n.copyable__text:before {\n  content: 'Title (default is \"Example\")';\n  display: block;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #505762;\n  margin-bottom: 4px;\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n}\n\n.copyable__text:before {\n  content: \"Content\";\n}\n\n.copyable__label,\n.copyable__text {\n  box-sizing: border-box;\n  display: block;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 0px 7px;\n  margin: 0;\n  margin-top: 32px;\n  background: #fff;\n  border-radius: 3px;\n  font-family: sans-serif;\n  position: relative;\n}\n\n.copyable__label,\n.copyable__text {\n  padding: 7px;\n}\n\n.copyable__text p {\n  margin: 8px 0;\n}\n\n.ck .copyable__label.ck-editor__nested-editable,\n.ck .copyable__text.ck-editor__nested-editable {\n  border: solid 1px #dde3f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
